(function () {
  function init(root) {
    var track = root.querySelector('[data-slider-track]');
    var slides = root.querySelectorAll('[data-slide]');
    var prevBtn = root.querySelector('[data-slider-prev]');
    var nextBtn = root.querySelector('[data-slider-next]');
    var dots = root.querySelectorAll('[data-slider-dot]');
    var n = slides.length;
    if (!track || n < 1) return;

    var index = 0;
    var timer = null;
    var startedAt = 0;
    var rafId = null;
    var paused = false;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5500;
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setTransform() {
      var pct = (index * 100) / n;
      track.style.transform = 'translateX(-' + pct + '%)';
    }

    function syncUi() {
      slides.forEach(function (s, j) {
        s.classList.toggle('is-active', j === index);
      });
      dots.forEach(function (d, j) {
        var on = j === index;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function go(i) {
      index = ((i % n) + n) % n;
      setTransform();
      syncUi();
      resetProgress();
    }

    function next() { go(index + 1); }
    function prev() { go(index - 1); }

    function resetProgress() {
      startedAt = performance.now();
      root.style.setProperty('--bff-hero-progress', '0');
    }

    function tickProgress(now) {
      if (!paused && n > 1) {
        var elapsed = now - startedAt;
        var pct = Math.min(1, elapsed / interval);
        root.style.setProperty('--bff-hero-progress', pct.toFixed(3));
        if (elapsed >= interval) {
          next();
        }
      }
      rafId = requestAnimationFrame(tickProgress);
    }

    function start() {
      if (n < 2 || prefersReducedMotion) return;
      paused = false;
      resetProgress();
      if (!rafId) rafId = requestAnimationFrame(tickProgress);
    }

    function stop() {
      paused = true;
    }

    setTransform();
    syncUi();

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        root.classList.add('is-ready');
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        go(parseInt(d.getAttribute('data-index'), 10));
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) start();
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { prev(); start(); }
      else if (e.key === 'ArrowRight') { next(); start(); }
    });

    var touchStartX = null;
    root.addEventListener('touchstart', function (e) {
      if (e.touches && e.touches.length === 1) {
        touchStartX = e.touches[0].clientX;
        stop();
      }
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (touchStartX == null) return;
      var endX = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : touchStartX;
      var dx = endX - touchStartX;
      touchStartX = null;
      if (Math.abs(dx) > 40) {
        if (dx < 0) next(); else prev();
      }
      start();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    start();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-hero-slider]').forEach(init);
  });
})();
